import React from "react";
import { MainLeftTitle } from "../../../_uiComponents/WrapperComponents";
import CxActivationReportGrid from "./views/CxActivationReportGrid";

export default function CxActivationReportWrapper() {
     return (
          <>
               <MainLeftTitle title="CX Always in Touch Activation Report" />

               <CxActivationReportGrid />
          </>
     );
}
